import React from 'react';
import styles from './ThankYou.module.css';
import { useAppSelector } from '../../../store/hooks';
import { selectAppParentPortalData } from '../../../store/reducer/appParentPortalDataSlice';
import { selectAppUserProfile } from '../../../store/reducer/appStateSlice';
import { ThankYouElement } from '../ThankYouElement';

export const MobileView = (): JSX.Element => {
  // REDUX
  const appParentPortalData = useAppSelector(selectAppParentPortalData);
  const userProfileData = useAppSelector(selectAppUserProfile);

  const thankYouElement = ThankYouElement();
  return (
    <React.Fragment>
      <div className={styles.thankYouDiv}>
        <main
          className={styles.thankYouPageMainGroup}
          id="thank-you-page-main-group"
        >
          <img
            className={styles.thankYouPageMainGroupIcon}
            id="thank-you-page-main-group-icon-mobile"
            alt=""
            src="assets/thankYou/thank-you-page-main-group-icon-mobile.svg"
          />
          <section
            className={styles.thankYouPageMainGroupContSection}
            id="thank-you-page-main-group-content"
          >
            <div className={styles.paymentSuccessful}>
              <img
                className={styles.thankYouMainGroupContentGIcon}
                id="thank-you-main-group-content-group-thank-you-image"
                alt=""
                src="assets/thankYou/thank-you-main-group-content-group-thank-you-image@3x.png"
              />
              <div className={styles.paymentSuccessfulDiv}>
                Payment Successful!
              </div>
              <div className={styles.lineDiv} />
            </div>
            <div className={styles.thankYouPageMainGroupContDiv}>
              <div className={styles.thankYouPageMainGroupContDiv1}>
                <div className={styles.yourSummaryDiv}>Your Summary</div>
                <div className={styles.thankYouPageMainGroupContDiv2}>
                  <div className={styles.frameDiv}>
                    <img
                      className={styles.thankYouTransactionIcon}
                      id="thank-you-transaction-icon"
                      alt=""
                      src="assets/thankYou/thank-you-transaction-icon.svg"
                    />
                    <div className={styles.frameDiv1}>
                      <div className={styles.productNameDiv}>
                        <div className={styles.thankYouPageMainGroupContDiv3}>
                          {thankYouElement.subscriptionPlanLabel}
                        </div>
                        <b className={styles.thankYouPageMainGroupContB}>
                          {thankYouElement.getSubscriptionPlanSubLabel(
                            (appParentPortalData.paymentRecord?.payment_detail
                              .payment_to ?? '') as string,
                          )}
                        </b>
                      </div>
                      <div className={styles.thankYouPageMainGroupContDiv4}>
                        <div className={styles.frameDiv2}>
                          <div className={styles.levelDiv}>Level</div>
                          <div className={styles.thankYouPageMainGroupContDiv5}>
                            {thankYouElement.subscriptionLevel(userProfileData)}
                          </div>
                        </div>
                        <div className={styles.frameDiv3}>
                          <div className={styles.frameDiv2}>
                            <div className={styles.levelDiv}>Date</div>
                            <div
                              className={styles.thankYouPageMainGroupContDiv6}
                            >
                              {thankYouElement.subscriptionDate}
                            </div>
                          </div>
                        </div>
                        <div className={styles.frameDiv3}>
                          <div className={styles.frameDiv2}>
                            <div className={styles.levelDiv}>Amount</div>
                            <div
                              className={styles.thankYouPageMainGroupContDiv6}
                            >
                              {/* {thankYouElement.subscriptionPlanPrice} */}
                              {`HKD $${
                                (appParentPortalData.paymentRecord
                                  ?.payment_response.amount_total as number) /
                                100
                              }`}
                            </div>
                          </div>
                        </div>
                        <div className={styles.frameDiv3}>
                          <div className={styles.frameDiv2}>
                            <div className={styles.levelDiv}>
                              Transfer Method
                            </div>
                            <div
                              className={styles.thankYouPageMainGroupContDiv6}
                            >
                              {/* {thankYouElement.subscriptionMethod} */}
                              {`${
                                appParentPortalData.paymentRecord
                                  ?.payment_response
                                  .payment_method_types as string[][0]
                              }`}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.thankYouPageMainGroupContDiv9}>
                <div className={styles.notesDiv}>Notes</div>
                <div className={styles.cardEmail}>
                  <div className={styles.frameDiv}>
                    <img
                      className={styles.thankYouTransactionIcon}
                      id="thank-you-email-icon"
                      alt=""
                      src="assets/thankYou/thank-you-email-icon.svg"
                    />
                    <div className={styles.frameDiv10}>
                      <div className={styles.emailInstructionsDiv}>
                        Email Instructions
                      </div>
                      <div className={styles.pleaseCheckYourEmailForFu}>
                        Please check your email for further instructions on how
                        to best experience Big Bang Lab.
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.cardEmail}>
                  <div className={styles.frameDiv}>
                    <img
                      className={styles.thankYouTransactionIcon}
                      id="thank-you-box-icon"
                      alt=""
                      src="assets/thankYou/thank-you-box-icon.svg"
                    />
                    <div className={styles.frameDiv10}>
                      <div className={styles.emailInstructionsDiv}>
                        Experiment Box
                      </div>
                      <div
                        className={styles.pleaseCheckYourEmailForFu}
                      >{`The first experiment box will be sent to your address in 3-5 working days.  `}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.lineDiv} />
            </div>
            <footer
              className={styles.thankYouPageMainGroupContFooter}
              id="thank-you-page-main-group-contact-us-group"
            >
              <div className={styles.rectangleDiv} />
              <img
                className={styles.thankYouPageMainGroupContIcon}
                id="thank-you-page-main-group-contact-us-group-bobo"
                alt=""
                src="assets/thankYou/thank-you-page-main-group-contact-us-group-bobo@3x.png"
              />
              <div className={styles.frameDiv13}>
                <div className={styles.haveAnyQuestions}>
                  have any questions?
                </div>
                <div
                  className={styles.thankYouPageMainGroupContButton}
                  id="thank-you-page-main-group-contact-us-button"
                >
                  {thankYouElement.contactUsButtonMobile}
                </div>
              </div>
            </footer>
          </section>
        </main>
        <header className={styles.headerGroup} id="common-navi-bar">
          <img
            className={styles.bbaLogoIcon}
            id="entry-header"
            alt=""
            src="assets/common/bba-logo.svg"
          />
        </header>
      </div>
    </React.Fragment>
  );
};
